module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.563/css/toolsmenu.css"